import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // useHistory helyett useNavigate React Router v6-ban
import axios from 'axios';
import { useCart } from '../../contexts/CartContext'; // ÚJ: Importáljuk a useCart hook-ot
import { PAYMENT_ENABLED } from '../../config/features';

const BookingDetails = ({ bookingId }) => { // bookingId-t propként kapja, vagy a URL-ből szedi ki
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // React Router v6 navigációhoz
  const { addToCart, removeFromCart, isInCart } = useCart(); // ÚJ: Használjuk a kosár funkciókat

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        setLoading(true);
        // Feltételezve, hogy van egy endpoint a foglalás lekérésére
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/bookings/${bookingId}`, { // MÓDOSÍTVA
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`, // Feltételezve, hogy a token a localStorage-ban van
          },
        });
        setBooking(response.data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (bookingId) {
      fetchBooking();
    }
  }, [bookingId]);

  const handleAddToCart = () => {
    if (booking) {
      addToCart(booking.id);
      alert(`A foglalás (ID: ${booking.id}) hozzáadva a kosárhoz!`);
    }
  };

  const handleRemoveFromCart = () => {
    if (booking) {
      removeFromCart(booking.id);
      alert(`A foglalás (ID: ${booking.id}) eltávolítva a kosárból!`);
    }
  };

  if (loading) return <p>Betöltés...</p>;
  if (error) return <p>Hiba: {error}</p>;
  if (!booking) return <p>Foglalás nem található.</p>;

  const PAYABLE_STATUSES = ['NOT_PAID', 'DEPOSIT_REQUESTED', 'DEPOSIT_PAID'];
  const pendingOfflineConfirmation = booking.selectedPaymentMethod && !booking.clientPaymentConfirmedAt;
  const showCartButton = PAYMENT_ENABLED && booking.status === 'APPROVED'
    && PAYABLE_STATUSES.includes(booking.paymentStatus)
    && !pendingOfflineConfirmation;
  const isBookingInCart = isInCart(booking.id);

  return (
    <div>
      <h1>Foglalás részletei (ID: {booking.id})</h1>
      <p>Státusz: {booking.status}</p>
      <p>Fizetési státusz: {booking.paymentStatus}</p>
      <p>Végleges ár: {booking.finalPrice} HUF</p>
      {/* ... egyéb foglalási adatok ... */}

      {showCartButton && (
        isBookingInCart ? (
          <button onClick={handleRemoveFromCart}>Eltávolítás a kosárból</button>
        ) : (
          <button onClick={handleAddToCart}>Kosárba tesz</button>
        )
      )}

      {/* ... egyéb gombok (pl. ajánlat elfogadása/elutasítása) ... */}
    </div>
  );
};

export default BookingDetails;